import { useEffect, useMemo } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

export const useListQueryParams = (
  selectedTab?: number,
  tabContainerIndex?: number,
) => {
  const { pathname } = useLocation();

  const [searchParams, setSearchParams] = useSearchParams();

  const searchParamsFromStorage = useMemo(() => {
    const newSearchParams =
      sessionStorage.getItem(pathname) ?? searchParams.toString();
    return new URLSearchParams(newSearchParams);
  }, [pathname, searchParams]);

  useEffect(() => {
    if (
      selectedTab !== undefined &&
      tabContainerIndex !== undefined &&
      selectedTab !== tabContainerIndex
    ) {
      return;
    }

    if (searchParamsFromStorage.toString() === searchParams.toString()) {
      return;
    }

    sessionStorage.setItem(pathname, searchParamsFromStorage.toString());

    console.log(
      "setting searchParams to searchParamsFromStorage",
      searchParamsFromStorage,
    );

    setSearchParams(searchParamsFromStorage, {
      replace: true,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    pathname,
    searchParams,
    searchParamsFromStorage,
    selectedTab,
    tabContainerIndex,
  ]);

  return searchParamsFromStorage;
};
